import attachments from "./attachments"
import entityConfig from "./entityConfig"
import initiateApp from "./initiateApp"
import issues from "./issues"
import items from "./items"
import performedWork from "./performedWork"
import workOrder from "./workOrder"
import workspaces from "./workspaces"

export default {
  attachments,
  entityConfig,
  initiateApp,
  issues,
  items,
  performedWork,
  workOrder,
  workspaces,
}
